export default "__VITE_ASSET__65029086__"